// this file is responsible for all icons used in this app we need to use this icon as AppIcons("abc")
import {BiDonateBlood , BiChevronDown,BiChevronUp ,BiMenu} from "react-icons/bi";
import {BsFillBookmarkFill , BsFillMoonFill} from "react-icons/bs";
import {HiDownload} from "react-icons/hi";
import {SiKofi} from "react-icons/si";
import {MdOutlineContentPaste} from "react-icons/md";
import {SlReload} from "react-icons/sl";


const AppIcons = (type:string, size = 20) => {
  switch (type?.toLowerCase()?.trim()) {
        case "menu":
        return <BiMenu style={{ width: `${size}px`, height: `${size}px` }} />;
        case "load":
        return <SlReload style={{ width: `${size}px`, height: `${size}px` }} />;
        case "donate":
        return <BiDonateBlood style={{ width: `${size}px`, height: `${size}px` }} />;
        case "bookmark":
        return <BsFillBookmarkFill style={{ width: `${size}px`, height: `${size}px` }} />;
        case "moon":
        return <BsFillMoonFill style={{ width: `${size}px`, height: `${size}px` }} />;
        case "download":
        return <HiDownload style={{ width: `${size}px`, height: `${size}px` }} />;
        case "kofi":
        return <SiKofi style={{ width: `${size}px`, height: `${size}px` }} />;
        case "paste":
        return <MdOutlineContentPaste style={{ width: `${size}px`, height: `${size}px` }} />;
        case "down":
        return <BiChevronDown style={{ width: `${size}px`, height: `${size}px` }} />;
        case "up":
        return <BiChevronUp style={{ width: `${size}px`, height: `${size}px` }} />;
    //   case "styled-component":
    //     return <SiStyledcomponents style={{ width: `${size}px`, height: `${size}px` }} />;
    //   case "tailwind":
    //     return <SiTailwindcss style={{ width: `${size}px`, height: `${size}px` }} />;
    //   case "firebase":
    //     return <TbBrandFirebase style={{ width: `${size}px`, height: `${size}px` }} />;
    //   case "ethereum":
    //     return <TbCurrencyEthereum style={{ width: `${size}px`, height: `${size}px` }} />;
    // default:
    //   return <BsBoxFill style={{ width: `${size}px`, height: `${size}px` }} />;
  }
};

export default AppIcons;